import { cn } from '@distribute/frontend/utils';
import { FC } from 'react';

const ChevronLeft: React.VFC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M15 18L9 12L15 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const MinusRoundSquare: React.VFC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13V11ZM16 13C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11V13ZM8 13H12V11H8V13ZM12 13H16V11H12V13ZM21 12C21 15.6946 20.3713 17.8395 19.1054 19.1054C17.8395 20.3713 15.6946 21 12 21V23C15.8054 23 18.6605 22.3787 20.5196 20.5196C22.3787 18.6605 23 15.8054 23 12H21ZM12 21C8.3054 21 6.16055 20.3713 4.89461 19.1054C3.62867 17.8395 3 15.6946 3 12H1C1 15.8054 1.62133 18.6605 3.48039 20.5196C5.33945 22.3787 8.1946 23 12 23V21ZM3 12C3 8.3054 3.62867 6.16055 4.89461 4.89461C6.16055 3.62867 8.3054 3 12 3V1C8.1946 1 5.33945 1.62133 3.48039 3.48039C1.62133 5.33945 1 8.1946 1 12H3ZM12 3C15.6946 3 17.8395 3.62867 19.1054 4.89461C20.3713 6.16055 21 8.3054 21 12H23C23 8.1946 22.3787 5.33945 20.5196 3.48039C18.6605 1.62133 15.8054 1 12 1V3Z"
        fill="currentColor"
      />
    </svg>
  );
};

const PlusRoundSquare: React.VFC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8H13ZM11 16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16H11ZM8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13V11ZM16 13C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11V13ZM11 8V12H13V8H11ZM11 12V16H13V12H11ZM8 13H12V11H8V13ZM12 13H16V11H12V13ZM21 12C21 15.6946 20.3713 17.8395 19.1054 19.1054C17.8395 20.3713 15.6946 21 12 21V23C15.8054 23 18.6605 22.3787 20.5196 20.5196C22.3787 18.6605 23 15.8054 23 12H21ZM12 21C8.3054 21 6.16055 20.3713 4.89461 19.1054C3.62867 17.8395 3 15.6946 3 12H1C1 15.8054 1.62133 18.6605 3.48039 20.5196C5.33945 22.3787 8.1946 23 12 23V21ZM3 12C3 8.3054 3.62867 6.16055 4.89461 4.89461C6.16055 3.62867 8.3054 3 12 3V1C8.1946 1 5.33945 1.62133 3.48039 3.48039C1.62133 5.33945 1 8.1946 1 12H3ZM12 3C15.6946 3 17.8395 3.62867 19.1054 4.89461C20.3713 6.16055 21 8.3054 21 12H23C23 8.1946 22.3787 5.33945 20.5196 3.48039C18.6605 1.62133 15.8054 1 12 1V3Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Download02: React.VFC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21 21H3M18 11L12 17M12 17L6 11M12 17V3"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const Minimize03: React.VFC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M20 20L15 15M15 15V20M15 15H20M20 4L15 9M15 9H20M15 9V4M4 4L9 9M9 9V4M9 9L4 9M4 20L9 15M9 15H4M9 15L9 20"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const Expand06: React.VFC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16 8L21 3M21 3H16M21 3V8M8 8L3 3M3 3L3 8M3 3L8 3M8 16L3 21M3 21H8M3 21L3 16M16 16L21 21M21 21V16M21 21H16"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ChevronRight: React.VFC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M9 18L15 12L9 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const XClose: React.VFC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M15 5L5 15M5 5L15 15"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Icons = {
  ChevronLeft,
  MinusRoundSquare,
  PlusRoundSquare,
  Download02,
  Minimize03,
  Expand06,
  ChevronRight,
  XClose,
};

const sizes = {
  xss: 'w-4 h-4',
  xs: 'w-5 h-5',
  sm: 'w-6 h-6',
  md: 'w-9 h-9',
  lg: 'w-12 h-12',
} as const;

type Props = {
  svg: React.VFC<React.SVGProps<SVGSVGElement>>;
  size?: keyof typeof sizes;
  className?: string;
};

export const Icon: FC<Props> = ({ svg: Svg, size, className = '' }) => {
  return <Svg className={cn(size && sizes[size], className)} />;
};
